import GalaxyChat from './GalaxyChat.vue';
import GalaxyChatList from './GalaxyChatList.vue';
export default {
  GalaxyChat,
  GalaxyChatList,
};
